import { Calendar } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/i18n/LanguageContext';

export const CTASection = () => {
  const { t } = useLanguage();

  return (
    <section className="py-20 md:py-32 cta-gradient" data-testid="cta-section">
      <div className="container-0g">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl md:text-5xl font-semibold tracking-tight text-white mb-6">
            {t('cta.title')}
          </h2>
          <p className="text-lg text-slate-300 mb-8 leading-relaxed">
            {t('cta.subtitle')}
          </p>
          <Button 
            className="btn-primary bg-teal-500 hover:bg-teal-400 text-white px-8 py-4 text-lg inline-flex items-center gap-2"
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            data-testid="cta-button"
          >
            <Calendar className="h-5 w-5" />
            {t('cta.button')}
          </Button>
        </div>
      </div>
    </section>
  );
};
